import React from 'react';
import { Spinner } from 'ui';
import { routes } from 'constants/config';
import useFetch from 'components/shared/hooks/useFetch';
import ConversationMetricsTableRow from './ConversationMetricsTableRow';
import ModuleLoadFailure from './ModuleLoadFailure';

const ConversationMetricsTable = ({ lessonIdString, groupId }) => {
  const { data, loading, error, runRequest } = useFetch(
    routes.LESSON_OVERVIEW.CONVERSATION_COMPLETION_METRICS(
      lessonIdString,
      groupId,
    ),
  );
  if (loading) return <Spinner />;
  if (error) {
    return <ModuleLoadFailure reload={runRequest} />;
  }
  const { conversationMetrics } = data;
  return (
    <div>
      <nav>
        <h2 className="SectionHeading">
          {t('conversations.lesson_overview.performance_title')}
        </h2>
      </nav>
      <section className="Module Module--bordered">
        <table className="PerformanceTable" id="lesson-performance-table">
          <thead>
            <tr>
              <th className="PerformanceTable-rowHead">#</th>
              <th>{t('questions.title')}</th>
              <th>{t('answers.title')}</th>
            </tr>
          </thead>
          <tbody>
            {conversationMetrics.map(conversationMetric => (
              <ConversationMetricsTableRow
                key={conversationMetric.questionId}
                conversationMetric={conversationMetric}
                lessonIdString={lessonIdString}
                groupId={groupId}
              />
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default props => <ConversationMetricsTable {...props} />;
